import N8nCheckbox from './Checkbox.vue';

export default N8nCheckbox;
